<template lang="html">
  <div class="single-select">
    <button type="button" class="btn-label btn btn-link-action"
      @click="toggleDropdown()">
      {{ labelText }} <i class="fas fa-angle-up"></i>
    </button>
    <dropdown-container :open="open" @cancel="cancelDropdown">
      <div class="selection">
        <div v-for="(option, index) in options"
        :key="'option-' + index"
        @click="toggleDropdown(index)"
        class="option px-4 py-1"
        :class="{ 'selected': index === selectedIndex }">
          {{ option }}
        </div>
      </div>
    </dropdown-container>
  </div>
</template>

<script>
import DropdownContainerComponent from '@/components/DropdownContainer';

export default {
  props: {
    stickyLabel: {
      type: Boolean,
      default: true
    },
    label: {
      type: String,
      default: 'select'
    },
    options: {
      type: Array,
      default() {
        return [];
      }
    },
    selectedIndex: {
      type: Number,
      default: -1
    },
    onChange: {
      type: Function,
      default(mutableSelectedIndex) {
        this.$emit('change', mutableSelectedIndex);
      }
    }
  },
  data() {
    return {
      open: false,
      mutableSelectedIndex: -1
    };
  },
  computed: {
    labelText() {
      if (this.stickyLabel || this.mutableSelectedIndex === -1) return this.label;
      return this.mutableSelectedIndex;
    }
  },
  methods: {
    toggleDropdown(index) {
      this.mutableSelectedIndex = index;
      if (this.open) {
        this.open = false;
        this.onChange(this.mutableSelectedIndex);
      } else {
        this.open = true;
      }
    },
    cancelDropdown() {
      this.open = false;
      this.mutableSelectedIndex = this.selectedIndex;
    }
  },
  components: {
    'dropdown-container': DropdownContainerComponent
  },
};
</script>

<style lang="scss" scoped>
.option {
  cursor: pointer;

  &:hover {
    background-color: var(--highlight);
  }
}

.option {
  font-family: Scandia-Regular, sans-serif;
  margin-left: -15px;
  margin-right: -15px;
}

.selection {
  text-align: left;
}

.selected {
  background-color: var(--action);
  color: var(--action-text);

  &:hover {
    background-color: var(--action);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Input/SingleSelect.vue